import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import Modal from "@cloudscape-design/components/modal";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { useState } from "react";

interface ReviewDisplayModalProps {
  isOpen: boolean;
  onClose: () => void;
  images: string[];
  reviewText?: string;
  reviewRating?: number;
  reviewerName?: string;
  title?: string;
}

export const ReviewDisplayModal = ({ 
  isOpen,
  onClose,
  images,
  reviewText,
  reviewRating,
  reviewerName,
  title = "Review Images"
}: ReviewDisplayModalProps) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <Modal
      visible={isOpen}
      onDismiss={onClose}
      header={`${title} - ${currentImageIndex + 1} of ${images.length}`}
      size="large"
    >
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', height: '70vh', maxHeight: '500px' }}>
        {/* Left: Review Text */}
        <div style={{ padding: '16px', borderRight: '1px solid #e9ebed', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          {reviewerName && (
            <div style={{ flexShrink: 0, marginBottom: '16px' }}>
              <Box fontWeight="bold" fontSize="heading-s">{reviewerName}</Box>
              {reviewRating && (
                <Box fontSize="body-s" color="text-body-secondary">
                  {reviewRating} stars
                </Box>
              )}
            </div>
          )}
          {reviewText && (
            <div style={{ flex: 1, overflow: 'auto', paddingRight: '8px', minHeight: 0 }}>
              <Box fontSize="body-m" lineHeight="body-m">
                {reviewText}
              </Box>
            </div>
          )}
        </div>
        
        {/* Right: Image Display */}
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
            <img
              src={images[currentImageIndex]}
              alt={`Review image ${currentImageIndex + 1}`}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                borderRadius: '8px'
              }}
            />
          </div>
          
          {/* Navigation Controls */}
          {images.length > 1 && (
            <Box display="flex" justifyContent="center">
              <SpaceBetween direction="horizontal" size="s">
                <Button
                  variant="normal"
                  iconName="angle-left"
                  onClick={prevImage}
                >
                  Previous
                </Button>
                <Box
                  padding={{ horizontal: 'm', vertical: 's' }}
                  style={{
                    backgroundColor: '#f2f3f3',
                    borderRadius: '4px',
                    fontSize: '14px'
                  }}
                >
                  {currentImageIndex + 1} / {images.length}
                </Box>
                <Button
                  variant="normal"
                  iconName="angle-right"
                  onClick={nextImage}
                >
                  Next
                </Button>
              </SpaceBetween>
            </Box>
          )}
        </div>
      </div>
    </Modal>
  );
};